import { useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import StatisticCircle from "./StatisticCircle";
import type { StatisticItem } from "../../Utils/Types";
import styles from "../../Styles/statistics-panel.module.css";

interface StatisticsPanelProps {
  title: string | undefined;
  subtitle?: string;
  statistics: StatisticItem[] | any;
  defaultOpen?: boolean;
}

export default function StatisticsPanel({
  title,
  subtitle,
  statistics,
  defaultOpen = false,
}: StatisticsPanelProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div className={styles.card}>
      <div className={styles.header} onClick={() => setIsOpen(!isOpen)}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        <div className={styles.chevron}>
          {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </div>
      </div>

      {isOpen && (
        <div className={styles.content}>
          <div className={styles.statisticsGrid}>
            {statistics?.length
              ? statistics.map((stats: StatisticItem, index: number) => (
                  <div key={index} className={styles.statisticItem}>
                    <StatisticCircle
                      value={stats.value}
                      color={stats.color || "#A3C86D"}
                      suffix={stats.suffix}
                      size="md"
                    />
                    <h3 className={styles.statisticLabel}>{stats.label}</h3>
                  </div>
                ))
              : null}
          </div>
        </div>
      )}
    </div>
  );
}
